/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const newTableTokens = {
  ContainerFontSizeBaseDefault: '14px',
  ContainerFontSizeHighDefault: '13px',
  ContainerFontSizeHigherDefault: '12px',
  ContainerSpacingVerticalHighDefault: '4px',
  ContainerSpacingVerticalHigherDefault: '4px',
  ContainerSpacingHorizontalHighDefault: '12px',
  ContainerSpacingHorizontalHigherDefault: '8px',
  HeaderBackgroundColorBaseDefault: '#ffffff',
  HeaderSpacingVerticalBaseDefault: '10px',
  HeaderSpacingVerticalLowDefault: '10px',
  HeaderSpacingHorizontalBaseDefault: '12px',
  HeaderSpacingHorizontalLowDefault: '12px',
  HeaderBorderColorBaseDefault: '#000000',
  RowBackgroundColorPositiveDefault: '#d6efec',
  RowBackgroundColorNoticeDefault: '#fcf0ee',
  RowBackgroundColorNegativeDefault: '#f8d2d8',
  RowBackgroundColorNeutralDefault: '#f4f4f4',
  RowBackgroundColorNeutralHover: '#dedfdf',
  RowBackgroundColorInformationalDefault: '#dfe8f4',
  RowBackgroundColorTotalDefault: '#eaf0f8',
  RowBackgroundColorTotalHover: '#dfe8f4',
  RowBackgroundColorSelectedDefault: '#dfe8f4',
  CellBorderColorBaseDefault: '#dedfdf',
  CellBorderColorBaseKeyboardFocus: '#285da3',
  CellBorderColorDividerDefault: '#285da3',
  CellSpacingVerticalBaseDefault: '10px',
  CellSpacingVerticalLowDefault: '20px',
  CellSpacingHorizontalBaseDefault: '12px',
  CellSpacingHorizontalLowDefault: '12px',
  CellBackgroundColorBaseDefault: '#ffffff',
  CellBackgroundColorBaseDown: '#eaf0f8',
  CellBackgroundColorPositiveDefault: '#d6efec',
  CellBackgroundColorNegativeDefault: '#f8d2d8',
  CellBackgroundColorNeutralDefault: '#ebecec',
  CellBackgroundColorNeutralHover: '#dedfdf',
  CellBackgroundColorInformationalDefault: '#dfe8f4',
  CellBackgroundColorTotalDefault: '#eaf0f8',
  CellBackgroundColorKeyDefault: '#fbf8f7',
  TwiddleIconSpacingSmallDefault: '2px',
  TwiddleIconSpacingMediumDefault: '4px',
  TwiddleIconForegroundColorBaseDefault: '#1c2222',
  TwiddleIconBackgroundColorBaseHover: '#ebecec',
  PinBackgroundColorBaseHover: '#ebecec',
  PinForegroundColorBaseDefault: '#1c2222',
  PinForegroundColorBaseDown: '#285da3',
  PinBorderRadiusBaseDefault: '3px',
  RibbonFontSizeBaseDefault: '12px',
  RibbonFontWeightBaseDefault: '500',
  RibbonFontColorPositiveDefault: '#1e6a60',
  RibbonFontColorNegativeDefault: '#c41936',
  RibbonFontColorPendingDefault: '#825a00',
  RibbonFontColorNoticeDefault: '#a0563f',
  RibbonFontColorNeutralDefault: '#232b2b',
  RibbonFontColorInformationalDefault: '#285da3',
  RibbonFontColorStaffDefault: '#000000',
  RibbonFontColorGreenDefault: '#1e6a60',
  RibbonFontColorRedDefault: '#ae1630',
  RibbonFontColorBlueDefault: '#1a3e6d',
  RibbonFontColorOrangeDefault: '#a0563f',
  RibbonFontColorYellowDefault: '#5b4b34',
  RibbonFontColorGrayDefault: '#232b2b',
  RibbonFontColorPinkDefault: '#5b4b34',
  RibbonBackgroundColorPositiveDefault: '#d6efec',
  RibbonBackgroundColorNegativeDefault: '#f8d2d8',
  RibbonBackgroundColorPendingDefault: '#fef8da',
  RibbonBackgroundColorNoticeDefault: '#fcf0ee',
  RibbonBackgroundColorNeutralDefault: '#ebecec',
  RibbonBackgroundColorInformationalDefault: '#dfe8f4',
  RibbonBackgroundColorStaffDefault: '#fcf0ee',
  RibbonBackgroundColorGreenDefault: '#d6efec',
  RibbonBackgroundColorRedDefault: '#f8d2d8',
  RibbonBackgroundColorBlueDefault: '#dfe8f4',
  RibbonBackgroundColorOrangeDefault: '#fae5de',
  RibbonBackgroundColorYellowDefault: '#fffced',
  RibbonBackgroundColorGrayDefault: '#ebecec',
  RibbonBackgroundColorPinkDefault: '#e2d5c2',
  RibbonBorderStyleBaseDefault: 'solid',
  RibbonBorderRadiusBaseDefault: '4px',
  RibbonBorderWidthBaseDefault: '1px',
  RibbonBorderColorPositiveDefault: '#5bc0b3',
  RibbonBorderColorNegativeDefault: '#e14963',
  RibbonBorderColorPendingDefault: '#f8d648',
  RibbonBorderColorNoticeDefault: '#ea957b',
  RibbonBorderColorNeutralDefault: '#232b2b',
  RibbonBorderColorInformationalDefault: '#285da3',
  RibbonBorderColorStaffDefault: '#efb09c',
  RibbonBorderColorGreenDefault: '#237c70',
  RibbonBorderColorRedDefault: '#c41936',
  RibbonBorderColorBlueDefault: '#285da3',
  RibbonBorderColorOrangeDefault: '#e57b5a',
  RibbonBorderColorYellowDefault: '#ddb31f',
  RibbonBorderColorGrayDefault: '#232b2b',
  RibbonBorderColorPinkDefault: '#7f6948',
  RibbonSpacingHorizontalBaseDefault: '12px',
  RibbonSpacingVerticalBaseDefault: '7px',
  RibbonShadowOffsetXBaseDefault: '1px',
  RibbonShadowOffsetYBaseDefault: '-1px',
  RibbonShadowBlurBaseDefault: '2px',
  RibbonShadowSpreadBaseDefault: '0px',
  RibbonShadowColorBaseDefault: 'rgba(21, 22, 26, 0.3)',
  StripeBackgroundColorCommonDefault: '#32b0a0',
  StripeBackgroundColorPreferredDefault: '#2c67b5',
  StripeBackgroundColorConvertibleDefault: '#634ba0',
  StripeBackgroundColorWarrantDefault: '#ea657f',
  StripeBackgroundColorOptionDefault: '#a7aaaa',
  StripeBackgroundColorPoolDefault: '#c4c4c4',
  StripeBackgroundColorGreenDefault: '#32b0a0',
  StripeBackgroundColorRedDefault: '#e14963',
  StripeBackgroundColorBlueDefault: '#2c67b5',
  StripeBackgroundColorOrangeDefault: '#ea957b',
  StripeBackgroundColorYellowDefault: '#fbe284',
  StripeBackgroundColorGrayDefault: '#a7aaaa',
  StripeBackgroundColorPurpleDefault: '#7358b8',
  StripeBackgroundColorPinkDefault: '#ed429f',
  StripeBackgroundColorGreenLightDefault: '#5bc0b3',
  StripeBackgroundColorRedLightDefault: '#e9778a',
  StripeBackgroundColorBlueLightDefault: '#8babd6',
  StripeBackgroundColorOrangeLightDefault: '#efb09c',
  StripeBackgroundColorYellowLightDefault: '#fcefb6',
  StripeBackgroundColorGrayLightDefault: '#c4c4c4',
  StripeBackgroundColorPurpleLightDefault: '#aa95d1',
  StripeBackgroundColorPinkLightDefault: '#fd90c4',
  StripeBackgroundColorBrownDefault: '#7358b8',
} as const;
